import { SxProps, Theme } from '@mui/material';
import { DUTIES_COLOURS, DUTIES_RADIUS } from './theme';

// ============================================================================
// Page Container Styles
// ============================================================================

/**
 * Main page container
 * Negative top margin to align with page layout
 */
export const pageContainerStyles: SxProps<Theme> = {
  mt: -1
};

/**
 * White card container
 * Main content card matching Figma design
 */
export const cardContainerStyles: SxProps<Theme> = {
  backgroundColor: DUTIES_COLOURS.background,
  borderRadius: DUTIES_RADIUS.md,
  boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
  padding: { xs: '16px', sm: '24px' },
  width: '100%',
  maxWidth: '100%',
  overflow: 'hidden',
  position: 'relative'
};

/**
 * Success alert banner styling
 */
export const successAlertStyles: SxProps<Theme> = {
  mb: 2
};

// ============================================================================
// Page Title Styles
// ============================================================================

/**
 * Main page title typography
 */
export const pageTitleStyles: SxProps<Theme> = {
  mb: 3
};

// ============================================================================
// Location Selector Styles
// ============================================================================

/**
 * Location selector section container
 */
export const locationSelectorContainerStyles: SxProps<Theme> = {
  mb: 3
};

/**
 * Location selector label typography
 */
export const locationSelectorLabelStyles: SxProps<Theme> = {
  mb: 0.5,
  fontWeight: 600,
  lineHeight: 1.2,
  display: 'block'
};

/**
 * Location selector FormControl wrapper
 */
export const locationSelectorFormControlStyles: SxProps<Theme> = {
  maxWidth: { xs: '100%', sm: '400px' },
  mt: 0.5
};

/**
 * Location selector Select component
 */
export const locationSelectorSelectStyles: SxProps<Theme> = {
  mt: 0,
  '& .MuiSelect-select': {
    color: DUTIES_COLOURS.primary
  },
  '& .MuiSelect-icon': {
    color: DUTIES_COLOURS.secondary
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: DUTIES_COLOURS.border
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: DUTIES_COLOURS.primary
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: 'primary.main'
  }
};

// ============================================================================
// Error Display Styles
// ============================================================================

/**
 * Error box container
 */
export const errorBoxContainerStyles: SxProps<Theme> = {
  mb: 3
};

// ============================================================================
// Table Container Styles
// ============================================================================

/**
 * Duties table wrapper
 * Handles responsive overflow behaviour
 */
export const tableWrapperStyles: SxProps<Theme> = {
  // Allow horizontal scroll on mobile if table is wider than container
  overflowX: 'auto',
  // Remove negative margin on mobile to prevent overflow
  mx: { xs: -2, sm: 0 },
  px: { xs: 2, sm: 0 }
};
